
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';

import { useToasts } from '@vromo/ui/components/Toasts';
import { trayDialogEvent, IntegrationsConfig, Platform, dataTestId } from '@vromo/models';
import { Details } from './common';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { useIntegrationsPage } from '../hooks';
import { firstLetterCap } from '@vromo/ui';





interface TrayCoonfigIframeProps {
    onComplete: () => void
    onCancel: () => void
}


/** renders the tray.io solution instance config iframe, and listen to its events
 * @note wont render if there is no wizard url
 */
export const TrayConfigIframe = observer<TrayCoonfigIframeProps>(({ onCancel, onComplete }) => {

    const { isLoading, setLoading, fetchedIntegrations } = useIntegrationsPage()
    const showToast = useToasts();
    const [iframeConfigured, setIframeConfigured] = useState(false)
    const [iframeLoaded, setIframeLoaded] = useState(false)
    const { platform } = useParams<{ platform: Platform }>()
    const instance = fetchedIntegrations.get(platform)!
    const { wording } = IntegrationsConfig[platform]!

    useEffect(() => {
        setLoading(true)

        const onmessage = (e: any) => {
            if (e.origin.includes("tray.io")) {

                switch (trayDialogEvent(e)) {
                    case "cancel":
                        if (!instance.completed) {
                            showToast(`Integration requires ${wording?.iframe}`, "warning")
                        }
                        setLoading(false)
                        onCancel()
                        break
                    case "ready":
                        setIframeLoaded(true)
                        // setLoading(false)
                        break
                    case "close":
                        if (!e.data?.authId) {
                            showToast(`Integration requires ${wording?.iframe}`, "warning")
                        }
                        setLoading(false)
                        onCancel()
                        break
                    case "finish":
                        setIframeConfigured(true)
                        window.removeEventListener("message", onmessage)
                        onComplete()
                        break
                    default:
                        console.error(e.data?.err ?? "unexpected error")
                        setLoading(false)
                        showToast(`${wording?.iframe} error`)
                        break
                }
            }
        }
        window.addEventListener("message", onmessage)
        return () => {
            window.removeEventListener("message", onmessage)
        }
    }, [])

    // listen to tray solution instance config dialog window events
    useEffect(() => {
        if (instance.wizardUrl && !iframeLoaded) {
            setLoading(true)
        }
    }, [instance, iframeLoaded])


    if (!instance?.features?.wizardUrl)
        return null

    return (
        <div data-testid={dataTestId.integration.iframe} style={{ width: '100%' }}>
            {
                !iframeConfigured &&
                <iframe src={instance.features.wizardUrl!} style={{
                    // height: iframeLoaded ? '500px' : '0px',
                    height:'500px' ,
                    maxHeight: '70%',
                    width: '100%',
                    border: '0px'
                }} />
            }
            {
                iframeConfigured &&
                <Details css={firstLetterCap}>
                    <h4 >
                        <FontAwesome icon="fa-solid fa-check" /> {`${wording?.iframe} was saved`}
                    </h4>
                </Details>
            }
        </div>
    );
});
